import type { ReactNode } from 'react';
import { isClerkAuthEnabled } from 'src/utils/clerkAuth';

import { ClerkAuthStateProvider } from './ClerkAuthStateProvider';
import { OutsetaProvider } from './OutsetaProvider';

export type { AuthProviderValue } from './auth-context';
export { useAuth, useAuthOptional } from './auth-context';

export const AuthProvider = ({ children }: { children: ReactNode }) =>
  isClerkAuthEnabled() ? (
    <ClerkAuthStateProvider>{children}</ClerkAuthStateProvider>
  ) : (
    <OutsetaProvider>{children}</OutsetaProvider>
  );
